import FlowireAPI from '../../../flowireapi/FlowireAPI';

async function simulateEconVars(graph) {
    // Calculate OPEX and CAPEX values
    let results;
    try {
        results = this.calculateOpexCapex(graph);
    } catch (e) {
        throw e;
    }
    let [opexSum, capexSum, feedCostSum, productCostSum, dutySum] = results;
    this.econVars.dutySum = dutySum;

    console.log('Capex:', capexSum);
    console.log('Opex:', opexSum);
    console.log('Feed Cost:', feedCostSum);
    console.log('Product Cost:', productCostSum);
    console.log('Duty Sum:', dutySum);

    const interestRate = this.econVars.interestRate;
    const years = this.econVars.years;
    let utilityCost = this.econVars.utilityCosts;
    let feedCostSumAnnual = this.econVars.feedCostSumAnnual;
    let productRevAnnual = this.econVars.productRevAnnual;
    let equipmentCapex = this.econVars.equipmentCapex;
    let laborCosts = this.econVars.laborCosts;
    let maintenanceCosts = this.econVars.maintenanceCosts;
    const additionalCapex = this.econVars.additionalCapex;
    let totalOpexDisplay = this.econVars.totalOpexDisplay;
    let additionalRevenueAnnual = this.econVars.additionalRevenueAnnual;
    let fcopOpexAnnual = this.econVars.fcopOpexAnnual;


    //calculate the utility cost, which is the cost of duty * electricity, assumes 8000 hours of operation this is yearly
    utilityCost = (dutySum * (this.econVars.elecCost / 1000) * 8000) 

    this.econVars.utilityCosts = utilityCost;

    this.econVars.opexSum = opexSum;

    equipmentCapex = capexSum
    this.econVars.equipmentCapex = equipmentCapex;

    // Factors for estimation of project fixed capital cost
    const langFactor = this.econVars.langFactor; 
    const materialFactor = this.econVars.materialFactor; // for carbon steel
    const locationFactor = this.econVars.locationFactor; // Australia

    const totalCapexInstalled = (capexSum) * langFactor * materialFactor * locationFactor + additionalCapex;

    const installationCosts = totalCapexInstalled - capexSum - additionalCapex;
    this.econVars.installationCosts = installationCosts;


    // Define constants for additional expense calculations
    const MAINTENANCE_RATE = this.econVars.maintenanceRate;
    const PROPERTY_TAX_INSURANCE = this.econVars.propertyTaxInsurance;
    const LAND_RENT = this.econVars.landRent;
    const ENV_CHARGES = this.econVars.envCharges;

    // Labor constants
    const OPERATOR_COUNT = this.econVars.operatorCount;
    const OPERATOR_SALARY = this.econVars.operatorSalary;
    const OPERATOR_BENEFITS_BASE = this.econVars.operatorBenefitsBase;
    const BENEFITS_PERCENTAGE = this.econVars.benefitsPercent;
    const LABOR_OVERHEAD_FACTOR = this.econVars.laborOverheadFactor;

    // Calculate base values
    const baseCapex = capexSum + this.econVars.additionalCapex;
    const baseOpex = opexSum + this.econVars.additionalOpex;
    const feedstockCosts = feedCostSum;
    const laborSalaries = OPERATOR_COUNT * OPERATOR_SALARY;
    const laborBenefits = OPERATOR_COUNT * OPERATOR_BENEFITS_BASE * BENEFITS_PERCENTAGE;
    laborCosts = (laborSalaries + laborBenefits) * LABOR_OVERHEAD_FACTOR;
    this.econVars.laborCosts = laborCosts;

    maintenanceCosts = totalCapexInstalled * MAINTENANCE_RATE;
    this.econVars.maintenanceCosts = maintenanceCosts;
    const propertyTaxInsuranceCost = totalCapexInstalled * PROPERTY_TAX_INSURANCE;
    const landRentCost = totalCapexInstalled * LAND_RENT;
    let landRentandPropertyTax = propertyTaxInsuranceCost + landRentCost;
    this.econVars.landRentandPropertyTax = landRentandPropertyTax;
    let environmentalCharges = totalCapexInstalled * ENV_CHARGES;
    this.econVars.environmentalCosts = environmentalCharges;

    // Calculate total OPEX by summing all components
    
    fcopOpexAnnual = laborCosts + maintenanceCosts + propertyTaxInsuranceCost + landRentCost + environmentalCharges + this.econVars.additionalOpex;
    this.econVars.fcopOpexAnnual = fcopOpexAnnual;
    const totalOpex = opexSum + fcopOpexAnnual

    console.log('Total Opex:', totalOpex);
    console.log('baseOpex:', baseOpex);
    console.log('laborCosts:', laborCosts);
    console.log('maintenanceCosts:', maintenanceCosts);
    console.log('propertyTaxInsuranceCost:', propertyTaxInsuranceCost);
    console.log('landRentCost:', landRentCost);
    console.log('environmentalCharges:', environmentalCharges);
    console.log('fcopOpexAnnual:', fcopOpexAnnual);


    //calculate feedcostsumAnnual
    feedCostSumAnnual = feedCostSum * 8000 / 24;
    this.econVars.feedCostSumAnnual = feedCostSumAnnual;

    // calculate annual product revenue
    productRevAnnual = productCostSum * 8000 / 24;
    this.econVars.productRevAnnual = productRevAnnual;

    //calculate annual total revenue
    let totalRevenueAnnual = productRevAnnual + additionalRevenueAnnual;
    console.log(totalRevenueAnnual)

    // Opex display value which includes feedcost
    totalOpexDisplay = totalOpex + feedCostSumAnnual;
    console.log('feedCostSumAnnual:', feedCostSumAnnual);
    this.econVars.totalOpexDisplay = totalOpexDisplay;
    console.log('total opex display:', totalOpexDisplay);


    // Update econVars with calculated values
    this.econVars.opexSum = opexSum;
    this.econVars.capexSum = capexSum;
    this.econVars.totalOpex = totalOpex;
    this.econVars.totalCapex = totalCapexInstalled;
    this.econVars.productRev = productCostSum;
    this.econVars.feedCostSum = feedCostSum;

    // Prepare data for the first API call (econPy type)
    let econData = {
        type: 'econPy',
        opexSum: opexSum,
        totalCapexInstalled: totalCapexInstalled,
        interestRate: interestRate,
        years: years,
        productRev: productCostSum,
        feedCost: feedCostSum,
        additionalRevenueAnnual: additionalRevenueAnnual,
        fcopOpexAnnual: fcopOpexAnnual,
    };

    let res;
    try {
        res = await FlowireAPI.authPost(
            '/api/econ',
            econData,
            this.getIdTokenClaims,
            this.isAuthenticated,
            (error) => {
                throw new Error(`HTTP error! status: ${error}`);
            }
        );
    } catch (error) {
        console.error("Error during the econPy API call:", error);
        throw error;
    }

    // Update econVars based on the first API response
    this.econVars.npvCalculated = res.result[1];
    this.econVars.yearsTArray = res.result[2];
    this.econVars.discountedCashflowCalculated = res.result[0];

    // Prepare data for the second API call (LCOP type)
    econData = {
        type: 'LCOP',
        opexSum: opexSum,
        totalCapexInstalled: totalCapexInstalled,
        interestRate: interestRate,
        years: years,
        productRev: productCostSum,
        feedCost: feedCostSum,
        additionalRevenueAnnual: additionalRevenueAnnual,
        fcopOpexAnnual: fcopOpexAnnual,
    };

    try {
        res = await FlowireAPI.authPost(
            '/api/econ',
            econData,
            this.getIdTokenClaims,
            this.isAuthenticated,
            (error) => {
                throw new Error(`HTTP error! status: ${error}`);
            }
        );
    } catch (error) {
        console.error("Error during the LCOP API call:", error);
        throw error;
    }

    const lcopResult = res.result;
    let streamMassFlow;
    graph.getLinks().forEach((link) => {
        if (link.prop('CustomName') === this.econVars.keyProductStream) {
            streamMassFlow = link.attributes['complete_Stream_Properties']['totalFlow'];
        }
    });

    // Calculate LCOP and update econVars
    this.econVars.LCOP = (lcopResult / streamMassFlow).toFixed(2);

    // Calculate economic potential if available
    if (this.simulatorService.solved_Dictionary?.streams) {
        const keyFeedStreamData = this.simulatorService.solved_Dictionary['streams'][Number(this.econVars.keyFeedStream)];
        if (keyFeedStreamData) {
            let keyFeedNo = keyFeedStreamData['totalFlow'];
            if (keyFeedNo !== null) {
                this.econVars.economicPotential = (productCostSum - feedCostSum) / (keyFeedNo * 8000 / 24);
            } else {
                alert('Please specify all Total Flow Values to calculate Economic Potential');
            }
        }
    }

    return [
        totalOpex.toFixed(2),
        totalCapexInstalled.toFixed(2),
        productCostSum.toFixed(2),
        feedCostSum.toFixed(2),
        capexSum.toFixed(2)
    ];
}

export default simulateEconVars;
